export default __webpack_public_path__ + "static/media/content.ab57d222.svg";